import { Config } from '@forgerock/javascript-sdk';
import envVar, { getSpecificEnv } from '@availity/env-var';
import { getCurrentEnv } from '../hooks/apiUrlResolver';
import authConstants from './authConstants';

const { FR_UI_PORT, AUTH_CLIENT_ID, REALM_PATH, JOURNEY_LOGIN, DEV_PORTAL_PORT } = authConstants;

const currentEnv = getCurrentEnv();
const isLocal = () => window.location.hostname === 'localhost';
const getDomainSuffix = () => window.location.host.toLowerCase().includes('.net') ? '.net' : '.com';

//  code for testing env variables identification
const specificEnv = getSpecificEnv();

const devPortalPrefixMap: Record<string, string> = { prod: 'preview', qap: 'qap-preview', qa: 'qua-preview' };
const devPortalPrefix = devPortalPrefixMap[specificEnv] ?? 'tst-preview';

const internalDevPortalPrefixMap: Record<string, string> = { prod: 'developer-portal-prd', qap: 'developer-portal-qap', qa: 'developer-portal-qua' };
const internalDevPortalPrefix = internalDevPortalPrefixMap[specificEnv] ?? 'developer-portal-tst';

console.log('specificEnv', specificEnv);
console.log('devPortalPrefix', devPortalPrefix);
console.log('internalDevPortalPrefix', internalDevPortalPrefix);

const getEnvPrefix = () => {
  if (currentEnv === 'prd') return '';
  if (currentEnv === 'qap') return 'qap-';
  if (currentEnv === 'qua') return 'qa-';
  return 'test-';
};

const getFREnvPrefix = () => {
  if (currentEnv === 'prd') return 'prod';
  if (currentEnv === 'qap') return 'qap';
  if (currentEnv === 'qua') return 'qua';
  return 'tst';
};

const getEssentialsUrl = () => 
   `https://${getEnvPrefix()}essentials.availity${getDomainSuffix()}`;

const getAMUrl = () => 
  `https://login-${getFREnvPrefix()}.availity${getDomainSuffix()}/am`;

const getLoginUrl = () => {
  if (isLocal()) return `http://localhost:${FR_UI_PORT}/#/login`;
  return `${getEssentialsUrl()}/static/public/onb/onboarding-ui-apps/availity-fr-ui/#/login`;
};

export const LOGIN_URL = getLoginUrl();
export const ESSENTIALS_URL = getEssentialsUrl();

export const initializeForgeRock = () => {
  const redirectUri = `${getEssentialsUrl()}/static/public/onb/onboarding-ui-apps/availity-fr-ui/callback`;
  
  Config.set({
    clientId: AUTH_CLIENT_ID,
    redirectUri,
    scope: 'openid profile email',
    serverConfig: {
      baseUrl: getAMUrl(),
      timeout: 5000,
    },
    realmPath: REALM_PATH,
    tree: JOURNEY_LOGIN,
  });
};

export const redirectToLogin = (): void => {
  try {
    const isLocalHost = isLocal();
    const safeGotoUrl = isLocalHost
      ? encodeURIComponent(`http://localhost:${DEV_PORTAL_PORT}/#/`)
      : encodeURIComponent(`${window.location.origin}/#/`);
    window.location.href = `${LOGIN_URL}?goto=${safeGotoUrl}`;
  } catch {
    // silently fail
  }
};

